import { render } from "./MatchList.vue?vue&type=template&id=bc99248e&scoped=true&ts=true"
import script from "./MatchList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchList.vue?vue&type=script&setup=true&lang=ts"

import "./MatchList.vue?vue&type=style&index=0&id=bc99248e&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc99248e"],['__file',"src/components/match/MatchList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc99248e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc99248e', __exports__)) {
    console.log('reload')
    api.reload('bc99248e', __exports__)
  }
  
  module.hot.accept("./MatchList.vue?vue&type=template&id=bc99248e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('bc99248e', render)
  })

}


export default __exports__